import PlayerHelper from '../../../../helpers/player'
import Html from 'common/components/html'
import { Transmission } from 'modules/transmission/types'

export interface PlayerProps {
  embedUrl?: string,
  leadCode?: string,
  transmission: Transmission
}

const Player = ({ transmission, embedUrl, leadCode }: PlayerProps) => {
  if (transmission.embedHtml) {
    return (
      <Html
        as="div"
        value={transmission.embedHtml}
        className="_h-full _w-full"
        dataTest="embed-html-container" />
    )
  }

  return (
    <iframe
      className="_w-full _h-full"
      src={PlayerHelper.getEmbedURLByProvider({
        mediaCode: transmission.mediaCode,
        url: transmission.url,
        provider: transmission.provider,
        embedUrl,
        leadCode,
        playerJwt: transmission.playerJwt,
        applicationCode: transmission.applicationCode,
        userCode: transmission.userCode
      })}
      frameBorder="0"
      allow="autoplay; fullscreen"
      allowFullScreen
      data-test="player-iframe" />
  )
}

export default Player
